import { styled } from '@pulse-web-ui/theme';

export const CreatedDocumentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const DocumentItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-start;
  cursor: pointer;
  padding: 12px 16px;
  border: ${({ theme }) => `1px solid ${theme?.colors?.neutral['30']}`};
  border-radius: calc(${({ theme }) => theme.common.radiusXL});

  @media (min-width: 768px) {
    justify-content: center;
  }
`;

export const NameContainer = styled.p`
  margin: 0;
  flex-basis: fit-content;
  cursor: pointer;
  line-height: 24px;
`;
